/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const RedOutlinedLem: any = (props: {}) => {
  return (
    <svg width="115" height="183" viewBox="0 0 115 183" fill="none">
      <path
        d="M84.5822 167.5H16.0418C21.4785 156.554 26.5426 146.363 31.6108 136.164C34.2122 130.929 36.8148 125.692 39.4694 120.349L40.0174 119.246L39.0423 118.494C37.9275 117.634 36.8339 116.77 35.7501 115.914C33.4026 114.061 31.1006 112.243 28.7263 110.575C2.715 92.2892 -5.78623 59.8919 8.14561 32.3302C21.1095 6.68924 52.9563 -5.25695 82.3524 5.38228L82.3525 5.38232C93.661 9.4743 102.233 15.7729 108.257 23.9314C114.284 32.0956 117.82 42.2044 118.919 54.0029C120.834 74.5807 118.051 94.9071 110.04 113.915L110.039 113.916C104.726 126.548 98.6746 138.808 92.4797 151.359C89.8579 156.67 87.2104 162.034 84.5822 167.5Z"
        stroke="#E30613"
        strokeWidth="3"
      />
      <path
        d="M101.839 182.062H60.6965C69.9041 153.016 81.462 125.406 91.7477 96.8323H122.174C115.273 125.471 108.61 153.573 101.839 182.062Z"
        fill="#FFE5B5"
      />
    </svg>
  );
};

export default RedOutlinedLem;
